import axiosInstance from './AxiosWrapper'
import { ENDPOINT_REFRESH_TOKENS } from './Endpoints'
import { getLocalUserId, getRefreshToken } from './TokenService'

let refreshTokenRequest = null

export const refreshTokens = async ({ silent = false } = {}) => {
  if (refreshTokenRequest) return refreshTokenRequest

  const refreshToken = getRefreshToken()
  const idUser = getLocalUserId()
  refreshTokenRequest = axiosInstance
    .post(
      ENDPOINT_REFRESH_TOKENS,
      {
        refreshToken,
        id: idUser,
      },
      {
        skipAuthRedirect: silent,
        skipGlobalErrorToast: silent,
      }
    )
    .finally(() => {
      refreshTokenRequest = null
    })

  return refreshTokenRequest
}
